const HEX_REG_EXP = /#([0-9a-fA-F]{1,2})([0-9a-fA-F]{1,2})([0-9a-fA-F]{1,2})/

/**
 * Converts hexa color code into hsl color code.
 * @param {string} hexColor
 */
export function hexToHsl(hexColor) {
    const hexSplit = HEX_REG_EXP.exec(hexColor)
    const isHexShortForm = hexColor.length === 4 // #fff => #ffffff

    const redHex = isHexShortForm ? `${hexSplit[1]}${hexSplit[1]}` : hexSplit[1]
    const greenHex = isHexShortForm ? `${hexSplit[2]}${hexSplit[2]}` : hexSplit[2]
    const blueHex = isHexShortForm ? `${hexSplit[3]}${hexSplit[3]}` : hexSplit[3]

    const redChannel = parseInt(redHex, 16) / 255
    const greenChannel = parseInt(greenHex, 16) / 255
    const blueChannel = parseInt(blueHex, 16) / 255

    const max = Math.max(redChannel, greenChannel, blueChannel)
    const min = Math.min(redChannel, greenChannel, blueChannel)

    let hue = (max + min) / 2
    let saturation = hue
    let light = hue

    if (max === min) {
        hue = 0
        saturation = 0
    } else {
        const diff = max - min
        saturation = light > 0.5 ? diff / (2 - max - min) : diff / (max + min)

        switch (max) {
            case redChannel:
                hue = (greenChannel - blueChannel) / diff + (greenChannel < blueChannel ? 6 : 0)
                break
            case greenChannel:
                hue = (blueChannel - redChannel) / diff + 2
                break
            case blueChannel:
                hue = (redChannel - greenChannel) / diff + 4
                break
        }
        hue /= 6
    }
    saturation = Math.round(saturation * 100)
    light = Math.round(light * 100)
    hue = Math.round(360 * hue)

    return {
        hue,
        light,
        saturation
    }
}
